import './blog.scss';
import * as React from 'react';
import { BlogPostCard } from '../../components/blog/blogPost';
import { Breadcrumbs } from '../../components/layout/breadcrumbs';
import { SectionTitle } from '../../components/layout/sectionTitle';
import { BackToTop } from '../../components/layout/shell/backToTop';
import Footer from '../../components/layout/shell/footer';
import { View } from '../../components/layout/view';
import { Pagination } from '../../components/navigation/pagination';
import { icons } from '../../content/icons';
import useBlogPage from '../../hooks/staticQueries/blog/useBlogPage';
import { useNoHero } from '../../hooks/useHeaderFade';
import { RoutePaths } from '../../routes';
export const BlogPage = ({ pageContext }) => {
    useNoHero();
    const { group, pageCount, index, additionalContext } = pageContext;
    // all blog posts (rather than paged blog posts) for if the user is filtering or if they are
    const { page } = useBlogPage();
    return (<View className="blog" title="Blog" noHero>
      {additionalContext?.blogPostType && (<Breadcrumbs crumbs={[{ title: 'Blog', to: RoutePaths.blog.blog(), icon: icons.back }, { title: additionalContext?.blogPostType.name }]}/>)}

      {!additionalContext?.blogPostType?.name && index === 1 && (<SectionTitle title={page.top_copy.header} description={page.top_copy.description} imageTicket={page.top_copy.icon[0].ticket}/>)}

      <div className="blog-posts-wrapper">
        {group.map((blogPost, i) => (<BlogPostCard blogPost={blogPost} key={blogPost.title} latest={i === 0}/>))}
      </div>

      {pageCount > 1 && <Pagination currentPage={index} totalPages={pageCount} newUrl={RoutePaths.blog.blog}/>}

      <Footer />
      <BackToTop />
    </View>);
};
export default BlogPage;
